import { render, staticRenderFns } from "./SystemHealth.vue?vue&type=template&id=8f9fe5e8&scoped=true&"
import script from "./SystemHealth.vue?vue&type=script&lang=js&"
export * from "./SystemHealth.vue?vue&type=script&lang=js&"
import style0 from "./SystemHealth.vue?vue&type=style&index=0&id=8f9fe5e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9fe5e8",
  null
  
)

export default component.exports